var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h4',{staticStyle:{"margin-top":"20px"}},[_vm._v("Please Wait While You are Being Redirected...")])}
var staticRenderFns = []

export { render, staticRenderFns }